import {Component, NgZone} from '@angular/core';
import {Events, IonicPage, MenuController, NavController, NavParams, Platform} from 'ionic-angular';

import {NetworkMonitorProvider} from '../../providers/network-monitor/network-monitor';
import {ProofProvider} from '../../providers/proof/proof';
import {AlertProvider} from '../../providers/alert/alert';
import {WindowProtectorProvider} from '../../providers/window-protector/window-protector';
import {FullscreenProvider} from '../../providers/fullscreen/fullscreen';

/**
 * Generated class for the ProofAfterEndPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-proof-after-end',
  templateUrl: 'proof-after-end.html',
})
export class ProofAfterEndPage {

  isOnline: boolean = false;

  constructor(
    private navCtrl: NavController,
    private platform: Platform,
    private networkMonitor: NetworkMonitorProvider,
    private zone: NgZone,
    private menu: MenuController,
    private proof: ProofProvider,
    private events: Events,
    private alertProvider: AlertProvider,
    public navParams: NavParams,
    private windowProtectorProvider: WindowProtectorProvider,
    private fullscreenProvider: FullscreenProvider,
  ) {
    this.networkMonitor.setCallback(null);
    this.networkMonitor.stop();

    if (this.platform.is('cordova')) {

      // Network Stuff
      let that = this;

      this.isOnline = this.networkMonitor.isOnline();
      this.networkMonitor.setCallback(function (isOnline, isWifi, isAirplaneMode) {
        that.zone.run(() => {
          that.isOnline = isOnline;
          console.log('ProofAfterEndPage - isOnline: ' + (isOnline ? 'Y' : 'N'));
        });
      });
      this.networkMonitor.start();
    } else {
      this.isOnline = true;
    }
  }

  doContinue() {
    let that = this;

    this.menu.enable(true);
    this.menu.swipeEnable(true);

    this.proof.setFinished();

    this.alertProvider.doWaiting('Processando...');

    // TODO: Verify if its using Wifi mode and warn if not
    // DONE: Bug when #popTo direct to ProofListPage
    this.navCtrl.popTo(this.navCtrl.getByIndex(0)).then(() => {
      this.fullscreenProvider.exitFullscreen().then((): void => {
        // Do nothing.
      });

      // that.events.publish('doProofUpdate', {
      //   doProofUpdate: true
      // });
      that.events.publish('doProofUpdate');

      this.windowProtectorProvider.stop();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProofAfterEndPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/proof-after-end/proof-after-end.ts